import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Dev-only: log direct fetch() calls that might bypass apiClient and cause HTML responses
if (process.env.NODE_ENV !== 'production') {
    const originalFetch = window.fetch;
    window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
        try {
            let url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : (input as Request).url;

            // In dev, reroute any direct '/api/...' calls to the backend origin (port 8080)
            if (typeof url === 'string' && url.startsWith('/api/')) {
                try {
                    const { getBackendBaseOrigin } = await import('./utils/network');
                    const apiBase = getBackendBaseOrigin();
                    const targetUrl = apiBase + url;
                    // rewrite silently

                    // Merge headers and ensure JSON + tenant header if available
                    const mergedHeaders: Record<string, string> = {};
                    const inputHeaders = (init && init.headers) || undefined;
                    if (inputHeaders) {
                        if (inputHeaders instanceof Headers) {
                            inputHeaders.forEach((v, k) => (mergedHeaders[k] = v));
                        } else if (Array.isArray(inputHeaders)) {
                            for (const [k, v] of inputHeaders as Array<[string, string]>) mergedHeaders[k] = v;
                        } else {
                            Object.assign(mergedHeaders, inputHeaders as Record<string, string>);
                        }
                    }
                    mergedHeaders['Accept'] = mergedHeaders['Accept'] || 'application/json';
                    const tenantId = localStorage.getItem('tenantId');
                    if (tenantId && !('X-Tenant-Id' in mergedHeaders)) mergedHeaders['X-Tenant-Id'] = String(tenantId);

                    const res = await originalFetch(targetUrl as any, { ...(init || {}), headers: mergedHeaders });
                    try {
                        const ct = res.headers.get('content-type') || '';
                        if (ct.includes('text/html')) {
                            const txt = await res.clone().text();
                            const head = txt.trim().slice(0, 32).toLowerCase();
                            if (head.startsWith('<!doctype') || head.startsWith('<html')) {
                                // silent
                            }
                        }
                    } catch { }
                    return res as any;
                } catch (err) {
                    // silent
                }
            }

            // Default path: call as-is
            const res = await originalFetch(input as any, init);
            try {
                const ct = res.headers.get('content-type') || '';
                if (ct.includes('text/html')) {
                    const txt = await res.clone().text();
                    const head = txt.trim().slice(0, 32).toLowerCase();
                    if (head.startsWith('<!doctype') || head.startsWith('<html')) {
                        // silent
                    }
                }
            } catch { }
            return res as any;
        } catch (e) {
            return originalFetch(input as any, init);
        }
    };
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);